export default __webpack_public_path__ + "media/images/delete2-73e25695d39d6525757f2a8d310af687.png";